/**
 * Firebase Web SDK — browser only. Config via CRA env vars (REACT_APP_FIREBASE_*).
 * Copy `.env.example` to `.env` and fill values from the Firebase console.
 */
import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

function hasMinimalConfig() {
  return Boolean(
    firebaseConfig.apiKey &&
      firebaseConfig.authDomain &&
      firebaseConfig.projectId &&
      firebaseConfig.appId,
  );
}

/** Resolves once Firebase app exists; null if env is incomplete (local shell without .env). */
export const firebaseApp = hasMinimalConfig() ? initializeApp(firebaseConfig) : null;

if (firebaseApp && typeof window !== 'undefined') {
  isSupported()
    .then((ok) => {
      if (ok && firebaseConfig.measurementId) {
        getAnalytics(firebaseApp);
      }
    })
    .catch(() => {
      /* Analytics unsupported (SSR, privacy tools, etc.) */
    });
}
